__turbopack_context__.v({
  "container": "qYchua_container",
  "desktopOnly": "qYchua_desktopOnly",
  "header": "qYchua_header",
  "mobileOnly": "qYchua_mobileOnly",
});
